import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/index.vue')
  },
  {
    path: '/room',
    name: 'HomeView',
    component: () => import('../views/HomeView/index.vue')
  },
  {
    path: '/article',
    name: 'arTicle',
    component: () => import('../views/article.vue')
  },
  {
    path: '/preview',
    name: 'preView',
    component: () => import('../views/preview.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})
export default router
